import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import { Invoice } from '../../invoice/invoice';
import { InvoiceService } from '../../invoice/invoice.service';
import { Po } from '../../po/po';
import { AuthService } from '../../auth.service';
import { PoService } from '../../po/po.service';

@Component({
  selector: 'app-po-reviewer-dashboard',
  templateUrl: './po-reviewer-dashboard.component.html',
  styleUrls: ['./po-reviewer-dashboard.component.css']
})
export class PoReviewerDashboardComponent implements OnInit {

  invoice = new Invoice();
  po = new Po();
  dashboardcountspo :any = {};
  dashboardcountsinvoice :any = {};
  awaitedpolist :any = [];
  recentactionlist :any = [];

  constructor( 
    private invoiceService: InvoiceService,
    private poService: PoService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
	 private auth: AuthService
    ) { }

  ngOnInit() {

    //this.CurrentUser = JSON.parse(localStorage.getItem('currentuser'))
   // console.log(this.CurrentUser)
 
    this.getAwaitedPO()

    this.getDashboardCountsPO()
    this.getDashboardCountsInvoice()

    this.getApproverRecentAction()
  }
  getDashboardCountsPO() {
    return this.poService.getDashboardCountsPO(this.auth.currentUserValue.userid)
               .subscribe(
                counts => {
                  this.dashboardcountspo = counts[0];
                 }
                );
  }

  getAwaitedPO() {
    return this.poService.getAwaitedPO(this.auth.currentUserValue.userid)

               .subscribe(
                polist => {
                  this.awaitedpolist = polist;
                  console.log(this.awaitedpolist)
                 }
                );
  }
  
  getDashboardCountsInvoice() {
    return this.invoiceService.getDashboardCountsFinance()
               .subscribe(
                counts => {
                  this.dashboardcountsinvoice = counts[0];
                 }
                );
  }
  //Approver Recent Action
  getApproverRecentAction() {
    return this.poService.getApproverRecentAction()
               .subscribe(
                poactionlist => {
                  this.recentactionlist = poactionlist;
                  console.log(this.recentactionlist);
                 }
                );
  }
}
